import { type ChangeEvent, useEffect, useState } from 'react'
import { EmentaIcon } from '@/assets/icons/ementa-icon'
import { useDebounce } from '@/hooks/ui/use-debounce'
import type { Curriculum } from '@/types/courses/curriculum'
import type { TableData } from '@/types/table/table-data'
import { createTableConfig } from '@/utils/create-table-config'

export const useChooseCurriculum = (curriculums?: Curriculum[]) => {
  const [isOpen, setOpen] = useState(false)
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewCurriculumId, setPreviewCurriculumId] = useState<string>()
  const [selectedCurriculums, setSelectedCurriculums] = useState<Curriculum[]>(
    []
  )
  const [localCurriculums, setLocalCurriculums] = useState<Curriculum[]>(
    curriculums || []
  )
  const [searchText, setSearchText] = useState('')
  const searchDebounce = useDebounce(searchText, 500)

  const tableConfig = createTable(localCurriculums)

  const handleSearchInput = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value)
  }

  function createCoursesButton(curriculum: string) {
    return (
      <button
        type="button"
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          event.stopPropagation()
          setPreviewOpen(true)
          setPreviewCurriculumId(curriculum)
        }}
        className="cursor-pointer"
      >
        <EmentaIcon />
      </button>
    )
  }

  function centerText() {
    return 'text-center'
  }

  function createTable(data?: Curriculum[]) {
    let tableData: TableData<Curriculum>[] = []
    if (data) {
      tableData = data.map((curriculum) => ({
        data: {
          ...curriculum,
          button: createCoursesButton(curriculum.id)
        }
      }))
    }

    return createTableConfig<Curriculum>(
      [
        { key: 'curriculumID', label: 'Currículo', hidden: false },
        {
          key: 'button',
          label: 'Disciplinas',
          hidden: false,
          width: '100px',
          getCustomStyle: centerText
        }
      ],
      tableData,
      'id'
    )
  }

  const handleCurriculumFilterBySearch = () => {
    const filter = curriculums?.filter((curriculum) =>
      curriculum.curriculumID.toLowerCase().includes(searchText.toLowerCase())
    )
    setLocalCurriculums(filter || [])
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    handleCurriculumFilterBySearch()
  }, [searchDebounce])

  return {
    states: {
      isOpen,
      selectedCurriculums,
      previewOpen,
      searchText,
      tableConfig,
      previewCurriculumId
    },
    actions: {
      setOpen,
      setSelectedCurriculums,
      setPreviewOpen,
      handleSearchInput
    }
  }
}
